// Files the user chose through the browser's own picker — react-dropzone's
// click, keyboard or drag handlers — carry none of the security context the
// Aspera SDK attaches to a selection made through its dialog, so Aspera cannot
// transfer them.
//
// Connect's availability is not stable while a user is choosing files: the SDK
// keeps polling after FAILED and can reach RUNNING later. Deciding the
// transport at upload time therefore risks handing a browser-picked file to
// Aspera, so the transport is latched onto the selection instead.
//
// Membership lives here rather than on the file: a browser File can be
// non-extensible, and a selection that silently failed to mark itself would be
// routed straight back into that race.
const browserSelections = new WeakSet();

export const markBrowserSelection = (files) => {
	Array.from(files ?? []).forEach((file) => {
		if( file && typeof file === 'object' ) {
			browserSelections.add(file);
		}
	});

	return files;
};

export const isBrowserSelection = (file) => Boolean(file)
	&& typeof file === 'object'
	&& browserSelections.has(file);
